import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactToPrint from "react-to-print";
import { Col, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";


const PNReportFee = () => {
  const printRef = useRef();

  const clearPagi = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);

  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  const colTable = [
    {
      Header: "Khoản mục",
      accessor: (item) => item.categoryName,
    },
    {
      Header: "Số tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.amount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];


  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        monthYear: filter.monthYear,
      };

      GET(`/pn/fee-company`, params, true)
        .then(({ data: { rows, summary } }) => {
          setData([...rows]);
          setSummary({ ...summary });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [timeNow, filter]);





  return (
    <React.Fragment>
      <Head title="Báo cáo chi phí"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo chi phí</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center mt-2">
                    CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM
                  </h5>
                  <h5 className="text-center">Báo cáo chi phí tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>

                  <Row>
                    <Col col={12}>
                      <div className="my-3">
                        <h5>Chi phí NCC và NH</h5>
                        <Table
                          loading={loading}
                          columns={colTable}
                          data={data}
                          notShowPagi={true}
                          customRow={() => (<>
                            <tr className="nk-tb-item odd font-weight-bold">
                              <td className="nk-tb-col">
                                <span> Tổng cộng</span>
                              </td>
                              <td align="right" className="nk-tb-col text-right">
                                <span>
                                  <NumericFormat
                                    value={summary?.totalWithOutMaterial || 0}
                                    displayType={'text'}
                                    decimalScale={2}
                                    thousandSeparator={','}
                                    thousandsGroupStyle="thousand"
                                  />
                                </span>
                              </td>
                            </tr>
                          </>
                          )}
                        ></Table>
                      </div>
                    </Col>

                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment >
  );
};

export default PNReportFee;
